import * as actions from './actions';
import * as api from './api';
import dataReducer from './data.reducer';
import * as functions from './functions';
import searchReducer from './search.reducer';

const reducers = {
  bookingData: dataReducer,
  bookingSearch: searchReducer,
};

export {
 actions, api, functions, reducers,
};
